// react
import React from 'react'

// components
import CreateDataFeedModal from '../components/CreateDataFeedModal.jsx'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import ListView from '_components/list-view/index.jsx'

import User from '../lib/User.js'

// libraries
import pretty from '@st-operations/uikit/lib/pretty.js'

// constants
const DELIVERY_TYPES_LABEL = {
  daily: 'Daily',
  hourly: 'Hourly',
  sample: 'Historical',
}

const STATUS_TYPES = {
  processed: 'Active',
  approved: 'Active',
  draft: 'Inactive',
  archived: 'Inactive',
}

// Feeds Page
class DataFeedsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      intervals: [],
      modalOpen: false,
    }
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCompanies()
      this.loadIntervals()
    })
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  loadIntervals = () => {
    window._api.get('/data-feeds/schema', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      if (resp && resp.interval) {
        this.setState({
          intervals: resp.interval.enum.map((filterOption) =>
            filterOption === 'sample'
              ? { label: DELIVERY_TYPES_LABEL.sample, value: 'sample' }
              : { label: pretty(filterOption), value: filterOption }
          ),
        })
      }
    })
  }

  getQs = () => {
    let qs = {}
    switch (window.location.pathname) {
      case '/event-feeds':
        qs.type = 'event'
        break
      case '/user-feeds':
        qs.type = 'user'
        break
    }
    return qs
  }

  render() {
    let { companies, intervals, modalOpen } = this.state

    return (
      <div id="data-feeds-page">
        <Header
          title="Data Feeds"
          actions={[
            {
              children: 'Create New Feed',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: '/data-feeds/:_id',
              sortable: true,
              width: 600,
            },
            {
              name: 'Type',
              key: 'type',
              sortable: true,
            },
            {
              key: 'company.name',
              link: '/companies/:company._id',
              name: 'Client',
              sortable: true,
            },
            {
              name: 'Delivery Type',
              key: 'interval',
              sortable: true,
              render: ({ interval }) => {
                return DELIVERY_TYPES_LABEL[interval] || '-'
              },
            },
            {
              key: 'status',
              name: 'Status',
              sortable: true,
              render: ({ status }) => {
                return STATUS_TYPES[status]
              },
            },
            {
              format: 'date',
              key: 'created_at',
              name: 'Created on',
              sortable: true,
            },
          ]}
          entities="data-feeds"
          filters={[
            { label: 'Client', name: 'company', options: companies, all: true },
            { name: 'interval', options: intervals, all: true },
          ]}
          fields={['company.name', 'company._id', 'created_at', 'interval', 'name', 'status']}
          queryString={this.getQs()}
          searchable={true}
          sort_key={'created_at'}
          sort_dir={-1}
          actions={[
            // TODO: Add BE actions
            { name: 'Delete', onClick: () => {}, icon: { icon: 'trashcan', type: 'outline' } },
            { name: 'Duplicate', onClick: () => {}, icon: { icon: 'uncheckall', type: 'outline' } },
          ]}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <CreateDataFeedModal onClose={this.toggleModal} />
        </Dialog>
      </div>
    )
  }
}

// export
export default DataFeedsPage
